import type { PspRules } from "@CommonTypes/backend/PspRules";
import type { Translate } from "src/i18n";

export type FrontFacings = PspRules["merchandising"]["leverage_alternative_orientations"];

/** The category's preference for front facings (`leverage_alternative_orientations`). */
export const frontFacingsTitle = (t: Translate<"common">): string =>
  t("planogramRules.frontFacings.title");

export const frontFacingsOptions = (
  t: Translate<"common">,
): Array<{ label: string; value: FrontFacings }> => [
  { label: t("planogramRules.frontFacings.frontOnly"), value: false },
  { label: t("planogramRules.frontFacings.turnedWhereAllowed"), value: true },
];
